import { createSlice } from "@reduxjs/toolkit";

import { getBlockList, addBlockList, updateBlockList, getBlockById, deleteBlockList } from "./thunk";

export const initialState = {
    blockList: {
        content: []
    },
    block: {},
    errors: {}
};

const BlockSlice = createSlice({
    name: 'Block',
    initialState,
    reducers: {},
    extraReducers: (builder) => {

        builder.addCase(getBlockList.fulfilled, (state: any, action: any) => {
            state.blockList = action.payload;
        });
        builder.addCase(getBlockList.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        builder.addCase(addBlockList.fulfilled, (state: any, action: any) => {
            console.log(action.payload)
            state.blockList.content.unshift(action.payload);
        });
        builder.addCase(addBlockList.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        builder.addCase(updateBlockList.fulfilled, (state: any, action: any) => {
            state.blockList.content = state.blockList.content.map((color: any) =>
                color.id === action.payload.id
                    ? { ...color, ...action.payload }
                    : color
            );
        });

        builder.addCase(updateBlockList.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        builder.addCase(deleteBlockList.fulfilled, (state: any, action: any) => {
            state.blockList.content = state.blockList.content.filter(
                (blockList: any) =>blockList.id !== action.payload
            );
            console.log(action.payload)
        });
        builder.addCase(deleteBlockList.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        builder.addCase(getBlockById.fulfilled, (state: any, action: any) => {
            state.block = action.payload;
        });
        builder.addCase(getBlockById.rejected, (state: any, action: any) => {
            state.error = action.payload || null;
        });

    }
});

export default BlockSlice.reducer;